module.exports = __webpack_public_path__ + "static/media/moyenstanding3.4533ea7b.jpg";